import * as actionTypes from "../../../../actionTypes";
import * as api from "../../../../../api/index";
import { toast } from 'react-toastify';

export const GetCampaignsBIZfusionWyzia = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getCampaignsBIZfusionWyzia(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CAMPAIGNS_BIZ_FUSION_WYZIA, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const CreateCampaignBIZfusionWyzia = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.createCampaignBIZfusionWyzia(formData);
    if (status === 201) {
      toast.success(data.message);
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
